import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-console" }
const _hoisted_2 = { class: "content" }

import ListGameName from "@/components/lists/list-game-name.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'name',
  props: {
    gameId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ListGameName, { "owner-id": __props.gameId }, null, 8, ["owner-id"])
    ])
  ]))
}
}

})